import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateTribeTemplateRequest,
  UpdateTribeTemplateRequest,
  ViewTribeTemplateRequest
} from './tribe-template.types';

import {
  requestCreateTribeTemplate,
  requestUpdateTribeTemplate,
  requestViewTribeTemplate
} from './tribe-template.actions';

export const useTribeTemplateApi = () => {
  const dispatch = useDispatch();

  const createTribeTemplate = useCallback(
    (requestData: CreateTribeTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestCreateTribeTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewTribeTemplate = useCallback(
    (requestData: ViewTribeTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestViewTribeTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateTribeTemplate = useCallback(
    (requestData: UpdateTribeTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateTribeTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createTribeTemplate, viewTribeTemplate, updateTribeTemplate };
};
